import { HTMLAttributes } from "react";
import "./DataWrapper.scss";

interface IDataWrapperProps extends HTMLAttributes<HTMLDivElement> {}

const DataWrapper = ({ ...props }: IDataWrapperProps) => {
  return (
    <div {...props} className={`data-wrapper  ${props.className ?? ""}`}>
      {props.children}
    </div>
  );
};

export default DataWrapper;
